import { render, staticRenderFns } from "./ModalCreateRule.vue?vue&type=template&id=12f374fa&scoped=true&"
import script from "./ModalCreateRule.vue?vue&type=script&lang=js&"
export * from "./ModalCreateRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f374fa",
  null
  
)

export default component.exports